// all_routes.tsx

import AdminRefundsPanel from '../components/AdminRefundsPanel';

export const all_routes = {
  // dashboard routes
  adminDashboard: '/admin-dashboard',
  parentDashboard: '/parent-dashboard',
  studentDashboard: '/student-dashboard',
  coachDashboard: '/coach-dashboard',
  adminMarketing: '/admin/marketing',
  aiEmailAssistant: '/admin/ai-email-assistant',

  blankPage: '/blank-page',
  calendar: '/calendar',
  dataTables: '/data-tables',
  tablesBasic: '/tables-basic',
  notes: '/notes',
  comingSoon: '/coming-soon',

  // auth routes routes
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  twoStepVerification: '/two-step-verification',
  success: '/success',
  emailVerification: '/email-verification',
  lockScreen: '/lock-screen',
  resetPassword: '/reset-password',
  resetPasswordSuccess: '/reset-password-success',
  mergeAccount: '/merge-account',

  //ui routes
  alert: '/ui-alert',
  accordion: '/ui-accordion',
  avatar: '/ui-avatar',
  badges: '/ui-badges',
  border: '/ui-border',
  breadcrums: '/ui-breadcrums',
  button: '/ui-buttons',
  buttonGroup: '/ui-button-group',
  cards: '/ui-cards',
  carousel: '/ui-carousel',
  colors: '/ui-colors',
  dropdowns: '/ui-dropdowns',
  grid: '/ui-grid',
  images: '/ui-images',
  lightbox: '/ui-lightbox',
  media: '/ui-media',
  modals: '/ui-modals',
  navTabs: '/ui-navtabs',
  offcanvas: '/ui-offcanvas',
  pagination: '/ui-pagination',
  placeholder: '/ui-placeholder',
  popover: '/ui-popover',
  progress: '/ui-progress',
  rangeSlider: '/ui-rangeslider',
  spinner: '/ui-spinner',
  sweetalert: '/sweetalert',
  toasts: '/ui-toasts',
  tooltip: '/ui-tooltip',
  typography: '/ui-typography',
  video: '/ui-video',
  clipboard: '/ui-clipboard',
  counter: '/ui-counter',
  dragandDrop: '/ui-drag-drop',
  rating: '/ui-rating',
  ribbon: '/ui-ribbon',
  stickyNotes: '/ui-sticky-notes',
  textEditor: '/ui-text-editor',
  timeLine: '/ui-timeline',
  scrollBar: '/ui-scrollbar',
  apexChat: '/ui-apexchat',
  chart: '/ui-chartjs',
  featherIcons: '/ui-feather-icon',
  falgIcons: '/ui-flag-icon',
  fantawesome: '/ui-fantawesome',
  materialIcon: '/ui-material-icon',
  pe7icon: '/ui-icon-pe7',
  simpleLineIcon: '/ui-simpleline',
  themifyIcon: '/ui-themify',
  typicon: '/ui-typicon',
  weatherIcon: '/ui-weather-icon',
  basicInput: '/forms-basic-input',
  checkboxandRadion: '/form-checkbox-radios',
  inputGroup: '/form-input-groups',
  gridandGutters: '/form-grid-gutters',
  formSelect: '/form-select',
  formMask: '/form-mask',
  fileUpload: '/form-fileupload',
  horizontalForm: '/form-horizontal',
  verticalForm: '/form-vertical',
  floatingLable: '/form-floating-labels',
  formValidation: '/form-validation',
  reactSelect: '/select',
  formWizard: '/form-wizard',
  dataTable: '/tables-basic',
  tableBasic: '/data-tables',
  iconicIcon: '/icon-ionic',

  //base-ui
  uiAlerts: '/ui-alerts',
  uiAccordion: '/ui-accordion',
  uiAvatar: '/ui-avatar',
  uiBadges: '/ui-badges',
  uiBorders: '/ui-borders',
  uiButtons: '/ui-buttons',
  uiButtonsGroup: '/ui-buttons-group',
  uiBreadcrumb: '/ui-breadcrumb',
  uiCards: '/ui-cards',
  uiCarousel: '/ui-carousel',
  uiColor: '/ui-color',
  uiDropdowns: 'ui-dropdowns',

  // pages routes
  error404: '/error-404',
  error500: '/error-500',
  underMaintenance: '/under-maintenance',

  // settings routes
  customFields: '/app-settings/custom-fields',
  invoiceSettings: '/app-settings/invoice-settings',

  bankAccount: '/financial-settings/bank-ccount',
  paymentGateways: '/financial-settings/payment-gateways',
  taxRates: '/financial-settings/tax-rates',

  schoolSettings: '/academic-settings/school-settings',
  religion: '/academic-settings/religion',

  connectedApps: '/general-settings/connected-apps',
  notificationssettings: '/general-settings/notifications-settings',
  profilesettings: '/general-settings/profile-settings',
  securitysettings: '/general-settings/security-settings',

  banIpAddress: '/other-settings/ban-ip-address',
  storage: '/other-settings/storage',

  emailSettings: '/system-settings/email-settings',
  emailTemplates: '/system-settings/email-templates',
  emailTemplatesBuilder: '/system-settings/email-templates/builder',
  emailTemplatesEdit: '/system-settings/email-templates/builder/:id',
  EmailTemplateSelector: '/system-settings/email-campaigns',
  emailCampaignRoutes: '/system-settings/email-campaign',
  gdprCookies: '/system-settings/gdpr-cookies',
  smsSettings: '/system-settings/sms-settings',
  optSettings: '/system-settings/otp-settings',
  formBuilder: '/system-settings/form-builder',

  socialAuthentication: '/website-settings/social-authentication',
  companySettings: '/website-settings/company-settings',
  language: '/website-settings/language',
  localization: '/website-settings/localization',
  preference: '/website-settings/preference',
  prefixes: '/website-settings/prefixes',

  // application routes
  todo: '/application/todo',
  email: '/application/email',
  videoCall: '/application/video-call',
  chat: '/application/chat',
  audioCall: '/application/audio-call',
  callHistory: '/application/call-history',
  fileManager: '/application/file-manager',

  //content routes
  pages: '/content/pages',
  cities: '/content/cities',
  states: '/content/states',
  testimonials: '/content/testimonials',
  countries: '/content/countries',
  faq: '/content/faq',
  // blog
  allBlogs: '/content/all-blogs',
  blogCategories: '/content/blog-categories',
  blogComments: '/content/blog-comments',
  blogTags: '/content/blog-tags',

  //userManagement routes
  deleteRequest: '/user-management/delete-request',
  rolesPermissions: '/user-management/roles-permissions',
  manageusers: '/user-management/manage-users',
  permissions: '/user-management/permissions',

  //support routes
  contactMessages: '/support/contact-messages',
  tickets: '/support/tickets',
  ticketGrid: '/support/ticket-grid',
  ticketDetails: '/support/ticket-details',

  // membership routes
  membershipplan: '/membership-plans',
  membershipAddon: '/membership-addons',
  membershipTransaction: '/membership-transactions',

  // Peoples Module
  playerGrid: '/player/player-grid',
  playerDetail: '/player/player-details',
  parentDetail: '/parent/parent-details',
  playerTimeTable: '/player/player-time-table',
  playerLeaves: '/player/player-leaves',
  playerFees: '/player/player-fees',
  playerResult: '/player/player-result',
  playerLibrary: '/player/player-library',
  PlayerList: '/player/player-list',
  addPlayer: '/player/add-player',
  editPlayer: '/player/edit-player',
  addParent: '/parent/add-parent',
  editParent: '/parent/edit-parent',
  coachDetail: '/coach/coach-details',
  coachGrid: '/coach/coach-grid',
  coachList: '/coach/coach-list',
  addCoach: '/coach/add-coach',
  editCoach: '/coach/edit-coach',
  parentGrid: '/parent/parent-grid',
  parentList: '/parent/parent-list',
  guardiansGrid: '/parent/guardians-grid',
  guardiansList: '/parent/guardians-list',

  // Management
  feesGroup: '/management/fees-group',
  feesType: '/management/fees-type',
  feesMaster: '/management/fees-master',
  feesAssign: '/management/fees-assign',
  collectFees: '/management/collect-fees',
  libraryMembers: '/management/library-members',
  libraryIssueBook: '/management/library-issue-book',
  libraryBooks: '/management/library-books',
  libraryReturn: '/management/library-return',
  playerList: '/management/players',
  sportsList: '/management/sports',
  hostelList: '/management/hostel-list',
  hostelType: '/management/hostel-type',
  hostelRoom: '/management/hostel-rooms',
  transportAssignVehicle: '/management/transport-assign-vehicle',
  transportVehicle: '/management/transport-vehicle',
  transportVehicleDrivers: '/management/transport-vehicle-drivers',
  transportPickupPoints: '/management/transport-pickup-points',
  transportRoutes: '/management/transport-routes',

  //Academic module
  AcademicReason: '/academic/academic-reason',
  classSyllabus: '/academic/class-syllabus',
  classSubject: '/academic/class-subject',
  classSection: '/academic/class-section',
  classRoom: '/academic/class-room',
  classRoutine: '/academic/class-routine',
  sheduleClasses: '/academic/schedule-classes',
  classes: '/academic/classes',
  classHomeWork: '/academic/class-home-work',
  exam: '/academic/exam',
  examSchedule: '/academic/exam-schedule',
  grade: '/academic/grade',
  examResult: '/academic/exam-result',
  examAttendance: '/academic/exam-attendance',
  classTimetable: '/academic/class-time-table',

  //Hrm module
  staff: '/hrm/staff',
  departments: '/hrm/departments',
  payroll: '/hrm/payroll',
  holidays: '/hrm/holidays',
  designation: '/hrm/designation',
  listLeaves: '/hrm/list-leaves',
  staffDetails: '/hrm/staff-details',
  staffPayroll: '/hrm/staff-payroll',
  staffLeave: '/hrm/staff-leave',

  approveRequest: '/hrm/approve-request',
  studentAttendance: '/hrm/student-attendance',
  coachAttendance: '/hrm/coach-attendance',
  staffAttendance: '/hrm/staff-attendance',
  addStaff: '/hrm/add-staff',
  editStaff: '/hrm/edit-staff',
  staffsAttendance: '/hrm/staffs-attendance',

  layoutDefault: '/layout-default',
  layoutMini: '/layout-mini',
  layoutRtl: '/layout-rtl',
  layoutBox: '/layout-box',
  layoutDark: '/layout-dark',

  // finance & accounts routes
  accountsIncome: '/accounts/accounts-income',
  accountsInvoices: '/accounts/accounts-invoices',
  accountsTransactions: '/accounts/accounts-transactions',
  expense: '/accounts/expense',
  expenseCategory: '/accounts/expense-category',
  invoice: '/accounts/invoice',
  addInvoice: '/accounts/add-invoice',
  editInvoice: '/accounts/edit-invoice',
  adminRefundsPanel: '/admin/refunds',

  // announcements routes
  events: '/announcements/events',
  noticeBoard: '/announcements/notice-board',

  //Report
  attendanceReport: '/report/attendance-report',
  classReport: '/report/class-report',
  studentReport: '/report/student-report',
  gradeReport: '/report/grade-report',
  leaveReport: '/report/leave-report',
  feesReport: '/report/fees-report',
  coachReport: '/report/coach-report',
  staffReport: '/report/staff-report',
  studentAttendanceType: '/report/student-attendance-type',
  dailyAttendance: '/report/daily-attendance',
  studentDayWise: '/report/student-day-wise',
  coachDayWise: '/report/coach-day-wise',
  staffDayWise: '/report/staff-day-wise',

  //page module
  profile: '/pages/profile',
  activity: '/pages/activities',
  tournamentAdminPage: '/pages/tournament',
  adminTournaments: '/admin/tournaments',

  // Team Management Routes
  teams: '/teams',
  createTeam: '/teams/create',
  editTeam: '/teams/edit',
  teamDetail: '/teams/detail',

  // Admin Registration Management Routes
  adminRegistrationManager: '/admin/registration-manager',
  adminSeasonEvents: '/admin/season-events',
  adminFormConfigs: '/admin/form-configs',
  adminFormPreview: '/admin/form-preview',

  // In the Spotlight
  inTheSpotlight: '/in-the-spotlight',
  spotlightManager: '/spotlight-manager',

  // For public/user-facing route:
  viewTickets: '/view-tickets',
  // For authenticated user route:
  myTickets: '/my-tickets',
  findTickets: '/find-tickets',

  // Page Builder Routes
  pageList: '/admin/pages',
  pageBuilder: '/admin/page-builder',
  pageBuilderNew: '/admin/page-builder/new',
  pageBuilderEdit: '/admin/page-builder/edit/:id',
  dynamicPage: '/page/:slug',

  // Payment Configuration
  paymentConfiguration: '/admin/payment-configuration',
};
